export const DOCUMENTS_CREATE_SAMPLE = `
    mutation M(
        $template_id: Long!
    ) {
        document_create_sample( template_id: $template_id ) {
            base64data
        }
    }
`;
